<script setup lang="ts">

import { useAuthorizationStore } from '@/components/authorization/model/AuthorizationRepository.ts'
import { useGlobalStateStore } from '@/components/commons/model/GlobalState.ts'
import router from '@/router'

const authorizationRepository = useAuthorizationStore()



const openScanner = () => {
  useGlobalStateStore().openScanner()
}

</script>

<template>
  <div class="layout-topbar flex justify-between items-center">
    <div >{{ authorizationRepository.getLoggedUser.firstName + ' '+ authorizationRepository.getLoggedUser.surname}}</div>

    <div class="flex">
      <Button class="p-link layout-topbar-button" @click="openScanner()" variant="link">
        <i class="pi pi-camera"></i>
      </Button>
      <Button class="p-link layout-topbar-button" @click="router.push('/mobile/user/profile')" variant="link">
        <i class="pi pi-cog"></i>
      </Button>
      <Button class="p-link layout-topbar-button" @click="authorizationRepository.logout()" variant="link">
        <i class="pi pi-sign-out"></i>
      </Button>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.layout-topbar-button.p-button-link {
  @apply text-gray-800;
}
</style>
